import React from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';

export class MultipleDayPicker extends React.Component {
    constructor(props) {
        super(props);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.state = {
            selectedDays: [...props.selectedDays],
            isReadOnly: props.isReadOnly
        };
    }

    handleDayClick(day, { selected }) {
        const { selectedDays } = this.state;
        if (selected) {
            const selectedIndex = selectedDays.findIndex(selectedDay =>
                DateUtils.isSameDay(selectedDay, day)
            );
            selectedDays.splice(selectedIndex, 1);
        } else {
            selectedDays.push(day);
        }
        this.setState({ selectedDays }, ()=>this.props.callback([...this.state.selectedDays]));
    }

    render() {
        const { selectedDays, isReadOnly } = this.state
        return (
            <div className={this.props.containerStyle}>
                <DayPicker
                    selectedDays={selectedDays}
                    onDayClick={isReadOnly ? ()=>{} : this.handleDayClick}
                    disabledDays={[{
                        before: new Date()
                    }]}
                />
            </div>
        );
    }
}
